import { useDispatch } from "react-redux";
import { styled } from "@mui/material";
import { useSelector } from "react-redux";
import LoginForm from "views/shared/LoginForm";
import { Dialog } from "@mui/material";

import { setLoginDialogOpen } from 'store/Shared.Slice';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
      maxWidth: 500,
      padding: theme.spacing(4),
    },
}));

const LoginPopup = () => {
    const dispatch = useDispatch();
    const { openLoginDialog } = useSelector(state => state.sharedState);

    return (
        <StyledDialog
            open={openLoginDialog}
        >
            <LoginForm 
                message="Please authenticate again" 
                onLoginSuccess={() => {
                    dispatch(setLoginDialogOpen(false));
                    window.location.reload()
                }}
            />
        </StyledDialog>
    )
}

export default LoginPopup;